import { useState } from "react";
import CommonIcon from "../../helpers/icons"
import { FormHelperText, MenuItem, Radio, Select, TextField } from "@material-ui/core";
import { TextareaAutosize } from "@material-ui/core";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { makeStyles } from '@material-ui/core/styles';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { error } from "jquery";

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#226EB7',
        },
    },
});

const useStyles = makeStyles({
    noBorderRadius: {
        '& .MuiInputBase-root.Mui-error': {
            border: 'none !important',
            boxShadow: 'none !important',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 0,
        },
        '&.MuiFormHelperText-contained': {
            marginLeft: '2px !important',
        },
    },
    customRadio: {
        color: 'rgba(0, 0, 0, 0.54)',
        '&$checked': {
            color: '#226EB7',
        },
    },
    checked: {},
});

const CancelSubscription = ({ appDetails, closeForm, cancelTrial, cancellationReason, cancellationMessage }) => {

    const classes = useStyles();

    let reasons = {
        "isCancelNow": true,
        "expiryDate": null,
        "reasonForCancelling": "",
        "feedBack": ""
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setReason((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const [error, setDateError] = useState(false);
    const [feedbackError, setFeedbackError] = useState(false);
    const handleChangetime = (value) => {
        setReason((prev) => ({
            ...prev,
            "expiryDate": value
        }))
    }

    const handleCancel = () => {
        if (reason.reasonForCancelling !== "" && reason.reasonForCancelling !== null) {
            if (reason.reasonForCancelling !== "Others" || (reason.reasonForCancelling == "Others" && reason.feedBack.trim() !== "")) {
                let data = {
                    ...reason,
                    expiryDate: null,
                    isCancelNow: true
                }
                setFeedbackError(false);
                setDateError(false);
                cancelTrial(data);
            }
            else {
                setFeedbackError(true);
                setDateError(false);
            }
        }
        else {
            setFeedbackError(false);
            setDateError(true)
        }

    }

    function formatAppMessage(message, appName) {
        const safeMessage = message.replace(
            "[appName]",
            `<span class="cancelpara14bold">${appName}</span>!`
        );

        return <span dangerouslySetInnerHTML={{ __html: safeMessage }} />;
    }

    const message = "Thanks for trying [appName] Your trial is about to be cancelled. You & your team can't use this service anymore. If you have any concerns, feel free to contact our support team at support@flaz.io. We are happy to help..."



    const [reason, setReason] = useState(reasons);


    return (
        <>
            <div className='d-flex justify-content-between px-4 mb-2'>
                <h3 className='headername3 pt-3 pb-0'>{appDetails?.name} - {appDetails.purchaseInfo.subscriptionStatus == "Trial" ? "Cancellation of Trial" : "Cancellation of Subscription"}</h3>
                <button
                    data-bs-dismiss="offcanvas"
                    className="offcavasclose"
                    onClick={() => closeForm()}
                >
                    <CommonIcon fileName={"Close"} />
                </button>
            </div>
            {/* <div className='row px-3'>
                <div className='col-xxl-2 col-xl-3 col-lg-4 col-md-5 col-sm-12'>
                    <h3 className='licenseheader'>Option for cancelling your trial</h3>
                </div>
                <div className='col-xxl-10 col-xl-9 col-lg-8 col-md-7 col-sm-12 pt-0'>
                    <div className="row">
                        <div className="col-xxl-9 col-xl-11 col-lg-12 col-md-12 col-sm-12 col-12">

                            <div className="d-flex align-items-start">
                                <Radio
                                    classes={{
                                        root: classes.customRadio,
                                        checked: classes.checked,
                                    }}
                                    checked={reason.isCancelNow == true}
                                    onChange={() => setReason({ ...reason, isCancelNow: true })}
                                    className="radioinputtrialcancel"
                                />
                                <div>
                                    <label className="radiolabelcancel">Cancel now</label>
                                    <p className='cancelpara text-justify ps-2 pe-2'>Cancel your trial now and stop using its service immediately. Choosing the option means that your organization won’t be able to try the trial version of this product again. This option available until 05 Oct 2024</p>
                                </div>

                            </div>
                            <div className="d-flex align-items-start">
                                <Radio
                                    classes={{
                                        root: classes.customRadio,
                                        checked: classes.checked,
                                    }}
                                    checked={reason.isCancelNow == false}
                                    onChange={() => setReason({ ...reason, isCancelNow: false })}
                                    className="radioinputtrialcancel"
                                />
                                <div>
                                    <label className="radiolabelcancel">End subscription on</label>
                                </div>


                            </div>
                            {reason.isCancelNow == false &&
                                <div style={{ marginLeft: '0px' }}>
                                    <MuiThemeProvider theme={theme}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                autoOk
                                                size="small"
                                                minDate={new Date()}
                                                disableToolbar
                                                format="dd-MMM-yyyy"
                                                margin="normal"
                                                value={reason.expiryDate}
                                                onChange={(date) => handleChangetime(date)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                error={dateError}
                                                helperText={dateError ? 'Select a date' : ''}
                                                className={classes.noBorderRadius}
                                                variant="inline"
                                                inputVariant="outlined"
                                            />
                                        </MuiPickersUtilsProvider>
                                    </MuiThemeProvider>
                                </div>
                            }

                        </div>
                    </div>

                </div>
            </div>
            <hr className='hrproducts ms-1 me-3 mt-4' /> */}
            <div className="row px-4">
                <div className="col-xxl-8 col-xl-10 col-lg-11 col-12">
                    <span className="cancelpara14 text-justify">
                        {formatAppMessage(cancellationMessage, appDetails.name)}
                    </span>
                </div>
            </div>
            <div className='row px-4 mt-3'>
                <div className='col-xxl-8 col-xl-10 col-lg-11 col-12'>
                    <label className="radiolabelcancel d-block ms-0">Reason for cancelling<span className="isrequired">*</span></label>
                    <Select
                        fullWidth
                        value={reason.reasonForCancelling}
                        onChange={(e) => { handleChange(e) }}
                        error={error}
                        name="reasonForCancelling"
                        variant="filled"
                        id="dropdown"
                        MenuProps={{
                            disablePortal: true,
                            PaperProps: {
                                className: 'select-dropdown-paper',
                            },
                            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                            transformOrigin: { vertical: 'top', horizontal: 'left' },
                        }}
                        sx={{
                            '& .MuiSelect-select': {
                                padding: '10px 14px', // Adjust padding as needed
                                backgroundColor: 'white'
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none', // Remove the border
                            },
                            '& .MuiSelect-icon': {
                                color: 'inherit', // Adjust icon color if needed
                            },
                            '&:before': {
                                borderBottom: 'none', // Remove the underline
                            },
                            '&:after': {
                                borderBottom: 'none', // Remove the underline on focus
                            },
                        }}
                        className="mt-1"
                    >
                        {cancellationReason.map((data) => (
                            <MenuItem value={data}>{data}</MenuItem>
                        ))}
                    </Select>
                    {error &&
                        <FormHelperText style={{ marginTop: '0px' }} error={error}>{"Please select a reason"}</FormHelperText>
                    }
                    <label className="radiolabelcancel d-block mt-3 ms-0 mb-1">Feedback{reason.reasonForCancelling == 'Others' && <span className="isrequired">*</span>} </label>
                    <TextareaAutosize
                        className={feedbackError ? "no-focus-borderred" : "no-focus-border"}
                        style={{
                            width: '100%',       // this replaces fullWidth
                            padding: '8px',
                            borderRadius: '0px',
                            fontSize: '14px'
                        }}
                        value={reason.feedBack}
                        onChange={(e) => { handleChange(e) }}
                        name="feedBack"
                        minRows={3}
                    />
                    {feedbackError &&
                        <FormHelperText style={{ marginTop: '-5px' }} error={feedbackError}>{"Please fill your feedback"}</FormHelperText>
                    }
                    {/* <textarea className='w-100 ms-0 me-3 textareacancel'></textarea> */}
                    <div className='mt-3'>
                        <button onClick={handleCancel} className='cancelbutton p-2'>{appDetails.purchaseInfo.subscriptionStatus == "Trial" ? "Cancel Trial" : "Cancel Subscription"}</button>
                    </div>
                </div>
            </div>
            {/* <div className='row px-3'>
                <div className='col-4'>

                </div>
                <div className='col-8 pt-0 pe-5 mt-2 ps-3'>
                    <button className='cancelbutton'>Cancel now</button>
                </div>

            </div> */}
        </>
    )
}

export default CancelSubscription